'use client';

import { useContext } from 'react';
import { useWatch } from 'react-hook-form';
import {
    CartContext,
    CartItemsFieldsContext,
    type CartItemsFields,
} from '@/entities/cart/model/cart-context';

/**
 * Live cart lines with `_id` keys from the provider's single useFieldArray.
 * Do NOT call useFieldArray again here — a second instance won't see updates
 * performed via the provider's field-array methods.
 */
export const useCartItemsFields = (): CartItemsFields => {
    return useContext(CartItemsFieldsContext);
};

/** Lightweight items snapshot for counts / empty checks. */
export const useCartItems = () => {
    const { formMethods } = useContext(CartContext);
    return useWatch({ control: formMethods.control, name: 'items' }) ?? [];
};
